import { useQuery } from "@tanstack/react-query";
import { characterGet } from "common/api/asocijator/character/character_api";
import { QUERY_KEYS } from "constant/react_query";

export const useCharacterGet = (id: string) => {
  const { data: character } = useQuery(
    [QUERY_KEYS.ASOCIJATOR_CHARACTER_GET, id],
    async () => {
      const result = await characterGet(id);
      return result;
    },
    { staleTime: Infinity }
  );
  const result =
    typeof character !== "undefined" && character !== "" ? character : null;
  return result;
};
